/* Nostalgia theme — lean vanilla JS */
(function () {
  "use strict";
  var body = document.body;

  // Mobile drawer
  function setDrawer(open){ body.classList.toggle('drawer-open', open); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { setDrawer(true); }
    if (e.target.closest('[data-menu-close]') || e.target.classList.contains('drawer-scrim')) { setDrawer(false); }
  });

  // Mobile search toggle
  var header = document.querySelector('header.site-header');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]') && header) {
      header.classList.toggle('search-open');
      if (header.classList.contains('search-open')) {
        var i = header.querySelector('.search input'); if (i) i.focus();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); if (header) header.classList.remove('search-open'); }
  });

  // Hero slideshow
  document.querySelectorAll('[data-slideshow]').forEach(function (box) {
    var slides = box.querySelectorAll('.hs-slide');
    if (slides.length < 2) return;
    var delay = parseInt(box.getAttribute('data-interval') || '5000', 10);
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('on');
    }, delay);
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    v += (btn.getAttribute('data-qty') === 'up') ? 1 : -1;
    if (v < 1) v = 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product variant picker: keep hidden id in sync + price/availability
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');
    function selectedOptions(){
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (el) {
        if (el.type === 'radio') { var c = form.querySelector('[data-option-index="'+el.getAttribute('data-option-index')+'"]:checked'); return c ? c.value : null; }
        return el.value;
      });
    }
    function update(){
      var opts = selectedOptions();
      var match = variants.find(function (v) { return v.options.every(function (o, k){ return o === opts[k]; }); });
      if (!match){ if(addBtn){addBtn.disabled=true;addBtn.textContent='Unavailable';} return; }
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price != null) priceEl.textContent = match.price;
      if (addBtn){ addBtn.disabled = !match.available; addBtn.textContent = match.available ? 'Add to cart' : 'Sold out'; }
    }
    form.addEventListener('change', function (e){ if (e.target.closest('[data-option-index]')) update(); });
    update();
  });
})();
